<!--
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2022-05-17 21:58:18
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2023-11-20 17:28:58
 * @FilePath: \web-qiankun\main\src\views\Approvainfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <!-- 2022年4月13日废弃 原因：把ifram嵌入的方式更换成乾坤调用子系统页面-->
  <div class="Basemaintain">
    <iframe
      id="bdIframe"
      :src="url"
      style="width: 100%;height:calc(100vh - 65px);"
      frameborder="0"
    />
  </div>
</template>
<script>
import { portalurl } from '@/api/main/main'
export default {
  name: 'Basemaintain',
  components: {
    // quitapplyinfo
  },
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.Geturlinfolist()
  },
  mounted () {
    // 暂时不用
    // const oIframe = document.getElementById('bdIframe')
    // const deviceHeight = document.documentElement.clientHeight
    // oIframe.style.height = Number(deviceHeight) + 'px' // 数字是页面布局高度差
    // document.title = '审批详情'
  },
  methods: {
    Geturlinfolist () {
      const par = {
        source: this.$route.query.source,
        serviceId: this.$route.query.sId
      }
      // 注意：standbyFuzzyConditions-------招标使用该参数备选的模糊条件 2022年4月14日增加了参数  standbyFuzzyConditions----0是单项目1是全过程项目
      portalurl(par).then(res => {
        if (res.status === 200) {
          this.url =
            window.location.protocol +
            '//' +
            window.location.host +
            res.data.url +
            '?businessId=' +
            this.$route.query.businessId +
            '&sId=' +
            this.$route.query.sId +
            '&approvalId=' +
            this.$route.query.approvalId +
            '&accurateConditions=' +
            this.$route.query.accurateConditions +
            '&type=' +
            this.$route.query.businessType
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.Basemaintain {
  min-height: 100vh;
}
</style>
